export interface AlertButton {
  label: string;
  action?: () => void; 
}

export interface Alert {
  name?: AlertType;
  header: string;
  message: string;
  buttons: AlertButton[];
}

export enum AlertType {
  OUT_OF_BOUNDARY = 'OUT_OF_PROJECT_BOUNDARY',
  RETURNED_TIME = 'RETURNED_TIME',
  UNSUBMITTED_TIME = 'UNSUBMITTED_TIME'
}